import { render } from "./Notice.vue?vue&type=template&id=2bc5f7f9&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"

import "./Notice.vue?vue&type=style&index=0&id=2bc5f7f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bc5f7f9"

export default script